"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const openapi_1 = require("../../openapi");
let TooManyResultsError = class TooManyResultsError extends Error {
    actualRecordsNum;
    threasholdNum;
    constructor(actualRecordsNum, threasholdNum) {
        const message = `Too many records. ${actualRecordsNum} records found. Maximum number of Records per query: ${threasholdNum}`;
        super(message);
        this.actualRecordsNum = actualRecordsNum;
        this.threasholdNum = threasholdNum;
    }
};
__decorate([
    (0, openapi_1.Schema)({
        type: 'number',
        description: 'The actual number of records retrieved from the database',
    })
], TooManyResultsError.prototype, "actualRecordsNum", void 0);
__decorate([
    (0, openapi_1.Schema)({
        type: 'number',
        description: 'The threshold number of records that was exceeded',
    })
], TooManyResultsError.prototype, "threasholdNum", void 0);
TooManyResultsError = __decorate([
    (0, openapi_1.ClassSchema)({
        description: 'Error thrown when the number of records retrieved from the database exceeds the maximum number of Records per query',
    })
], TooManyResultsError);
exports.default = TooManyResultsError;
